import * as a from '~js/utils/attributes';
import * as c from '~js/utils/classes';
import * as stngs from '~js/utils/settings';
import { LoadPhotoswipe } from '~js/components/load-photoswipe';
import { a11y } from '~js/components/a11y';

const options$1 = {
  history: false,
  focus: false,
  mainClass: c.classes$F.popupNotification,
  closeOnVerticalDrag: false,
};

export class NotificationPopup {
  constructor(button) {
    this.button = button;
    this.a11y = a11y;
    this.notificationPopupHtml = this.button.getAttribute(a.attributes$y.notificationPopup);

    if (this.notificationPopupHtml.trim() !== '') {
      this.init();
    }
  }

  init() {
    const items = [
      {
        html: this.notificationPopupHtml,
      },
    ];

    this.a11y.state.trigger = this.button;

    new LoadPhotoswipe(items, options$1, stngs.settings$7.templateIndex);
  }
}